module.exports = __webpack_public_path__ + "img/business.7230ac8a.jpg";